import script from "./sortFolder.vue?vue&type=script&setup=true&lang=js"
export * from "./sortFolder.vue?vue&type=script&setup=true&lang=js"

import "./sortFolder.vue?vue&type=style&index=0&id=3807cab6&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3807cab6"]])

export default __exports__